// import "@deer-ui/core/default.css";

export function RootWrapper({ children, theme }) {
  return children;
}
